module.exports = "/_next/static/images/5c2edf3f13a4be55c5a8d8d21916568f-hero-variant-xs.png";